/**
 * Spustí stažení souboru z dané (same-origin) URL pomocí skrytého odkazu s atributem `download`.
 *
 * Oproti `window.open(url, '_blank')` se soubor nestáhne do nové prázdné záložky, ale rovnou se
 * nabídne ke stažení. Pokud má uživatel v prohlížeči zapnuté „zeptat se, kam soubor uložit“,
 * zobrazí se nativní dialog pro výběr umístění; jinak se uloží do výchozí složky pro stahování.
 *
 * @param url       adresa souboru ke stažení (musí být ze stejného originu, aby se atribut `download` uplatnil)
 * @param fileName  volitelný název souboru; pokud není uveden, použije se název z hlavičky
 *                  `Content-Disposition`, případně z URL
 */
export const downloadFile = (url: string, fileName?: string): void => {
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName ?? '';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    link.remove();
};
